import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Box,
} from "@mui/material";
import Card from "../../components/Card";
import SalesChart from "../Dashboard/SalesChart";
import ProductTable from "./ProductTable";
import Modal from "components/Modal/Pawn/BuyProduct/ModalCreate"; // Import Modal component
import "../../assets/css/Dashbord.css"; // Corrected CSS file name to Dashboard.css
import { GradientButton } from "../../components/GradientButton";
import { useAuth } from "hooks/useAuth";
//Import Icon Mui
import InboxIcon from "@mui/icons-material/Inbox";
import OutboxIcon from "@mui/icons-material/Outbox";
import TrendingUpIcon from "@mui/icons-material/TrendingUp"; // Import TrendingUpIcon
import api from "_api";
import { useNavigate } from "react-router-dom";
import { formatCurrency2Digit } from "utils/helpers/format";
import cashIcon from "../../assets/icons/cash-icon.svg"; // Import CashIcon
import transferIcon from "../../assets/icons/transfer-icon.svg"; // Import transferIcon
import bankCheckIcon from "../../assets/icons/bank-check-icon.svg"; // Import bankCheckIcon
import creditCardIcon from "../../assets/icons/credit-card-icon.svg"; // Import creditCardIcon

const Dashboard = ({ className }) => {
  const [dateRange, setDateRange] = useState("day");
  const [isModalOpen, setModalOpen] = useState(false); // State for modal open
  const [fetchData, setFetchData] = useState({});
  // console.log("fetchData >>>>> ", fetchData);
  // console.log("logs7Days =>", fetchData.logs7Days);
  const logs = fetchData?.logs7Days || [];
  const totalRevenue = logs.reduce((sum, day) => sum + (day.revenue || 0), 0);
  const totalExpenditure = logs.reduce((sum, day) => sum + (day.expenditure || 0), 0);
  const totalProfit = logs.reduce((sum, day) => sum + (day.profit || 0), 0);

  

  const navigate = useNavigate();

  const handleDateRangeChange = (event) => {
    setDateRange(event.target.value);
  };
  // Request the USB device using WebUSB API
  // const device = await navigator?.usb?.requestDevice({
  //   filters: [{ vendorId: 0x04e6, productId: 0x5810 }],
  // });
  // console.log("Auth", useAuth());
  // const fetchDashboardData = async () => {
  //   try {
  //     const { data } = await api.product.getDashboard();
  //     setFetchData(data);
  //   } catch (err) {
  //     console.error("error:", err);
  //   }
  // };
  const fetchDashboardData = async (range = "week") => {
    try {
      const { data } = await api.product.getDashboard(range);
      console.log("res data >>> ",JSON.stringify(data));
      setFetchData(data);
    } catch (err) {
      console.error("error:", err);
    }
  };

  useEffect(() => {
    // console.log("📡 range ที่ fetch จริง:", dateRange);
    fetchDashboardData(dateRange);
  }, [dateRange]);
  useEffect(() => {
    console.log(fetchData);
  }, [fetchData]);
  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };
  // Send device details to the backend
  // setStatus("Sending device details to the server...");
  // const result = await api.pawn.connectUsbDevice({
  //   vendorId: device?.vendorId,
  //   productId: device?.productId,
  // });

  return (
    <div className={className + " dashboard-container"}>
      {/* <Container className={"dashboard-container"}> */}
      <Typography variant="h4" className="dashboard-title">
        Dashboard
      </Typography>

      {/* <Grid container spacing={2} style={{ marginTop: "20px" }}>
        <Grid item xs={12} sm={6} md={6}>
          <Card
            title="เงินต้ังต้น"
            value={formatCurrency2Digit(fetchData?.companyBudget?.budget || 0)}
            info="{metric.info}"
            className="card-item"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <Card
            title="ยอดเงินคงเหลือ"
            value={formatCurrency2Digit(
              fetchData?.companyBudget?.remaining_budget || 0
            )}
            info="{metric.info}"
            className="card-item"
          />
        </Grid>
      </Grid> */}

      <RadioGroup
        row
        // className="radio-group"
        value={dateRange}
        onChange={handleDateRangeChange}
        sx={{ mt: 3, mb: 2, gap: 2 }}
      >
        <FormControlLabel value="day" control={<Radio />} label="วันนี้" />
        <FormControlLabel
          value="week"
          control={<Radio />}
          label="สัปดาห์นี้ (จันทร์-อาทิตย์)"
        />
        <FormControlLabel value="month" control={<Radio />} label="เดือนนี้" />
        <FormControlLabel value="year" control={<Radio />} label="ปีนี้" />
      </RadioGroup>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <Card
            title="รายรับทั้งหมด"
            value={formatCurrency2Digit(fetchData?.sumRevenue || 0)}
            info="{metric.info}"
            className="card-item"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <Card
            title="รายจ่ายทั้งหมด"
            value={formatCurrency2Digit(fetchData?.sumAllExpenditure || 0)}
            info="{metric.info}"
            className="card-item"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <Card
            title="จำนวนสินค้าที่ขายทั้งหมด"
            value={formatCurrency2Digit(fetchData?.sumSellingProductAmount || 0)}
            info="{metric.info}"
            className="card-item"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Card
            title="ยอดซื้อสินค้าเข้า"
            value={formatCurrency2Digit(fetchData?.sumBuyProduct || 0)}
            info="{metric.info}"
            className="card-item"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Card
            title="ยอดขายสินค้าออก"
            value={formatCurrency2Digit(fetchData?.sumSellProduct || 0)}
            info="{metric.info}"
            className="card-item"
          />
        </Grid>
      </Grid>

      <Typography
        variant="h6"
        className="dashboard-subtitle"
        style={{ marginTop: "20px", marginBottom: "12px" }}
      >
        รายงานรายรับ - รายจ่าย
      </Typography>

      <Grid container spacing={2} className="chart-container">
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <Card
            title="รายรับจากเงินสด"
            // value={formatCurrency2Digit(fetchData?.sumProfitFromInterest || 0)}
            value={formatCurrency2Digit(fetchData?.sumSellByChannel?.["เงินสด"] || 0)}
            icon={
              <img
                src={cashIcon}
                alt="Cash Icon"
                style={{ width: "24px", height: "24px" }}
              />
            }
            color="#00BB9F"
            className="card-item"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <Card
            title="รายรับจากเงินโอน"
            // value={formatCurrency2Digit(fetchData?.sumProfitFromSelling || 0)}
            value={formatCurrency2Digit(fetchData?.sumSellByChannel?.["โอนผ่านธนาคาร"] || 0)}
            icon={
              <img
                src={transferIcon}
                alt="Cash Icon"
                style={{ width: "24px", height: "24px" }}
              />
            }
            color="#00BB9F"
            className="card-item"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <Card
            title="รายรับจากเช็คธนาคาร"
            // value={formatCurrency2Digit(0)}
            value={formatCurrency2Digit(fetchData?.sumSellByChannel?.["เช็ค"] || 0)}
            icon={
              <img
                src={bankCheckIcon}
                alt="Check Icon"
                style={{ width: "24px", height: "24px" }}
              />
            }
            color="#00BB9F"
            className="card-item"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <Card
            title="รายรับจากบัตรเครดิต"
            // value={formatCurrency2Digit(fetchData?.sumAllProductCostPrice || 0)}
            value={formatCurrency2Digit(fetchData?.sumSellByChannel?.["บัตรเครดิต"] || 0)}
            icon={
              <img
                src={creditCardIcon}
                alt="Credit Icon"
                style={{ width: "24px", height: "24px" }}
              />
            }
            color="#00BB9F"
            className="card-item"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <Card
            title="รายจ่ายจากเงินสด"
            // value={formatCurrency2Digit(fetchData?.sumProfitFromInterest || 0)}
            value={formatCurrency2Digit(fetchData?.sumBuyByChannel?.["เงินสด"] || 0)}
            icon={
              <img
                src={cashIcon}
                alt="Cash Icon"
                style={{ width: "24px", height: "24px" }}
              />
            }
            color="#D32F2F"
            className="card-item"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <Card
            title="รายจ่ายจากเงินโอน"
            // value={formatCurrency2Digit(fetchData?.sumProfitFromSelling || 0)}
            value={formatCurrency2Digit(fetchData?.sumBuyByChannel?.["โอนผ่านธนาคาร"] || 0)}
            icon={
              <img
                src={transferIcon}
                alt="Transfer Icon"
                style={{ width: "24px", height: "24px" }}
              />
            }
            color="#D32F2F"
            className="card-item"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <Card
            title="รายจ่ายจากเช็คธนาคาร"
            // value={formatCurrency2Digit(0)}
            value={formatCurrency2Digit(fetchData?.sumBuyByChannel?.["เช็ค"] || 0)}
            icon={
              <img
                src={bankCheckIcon}
                alt="Bank Check Icon"
                style={{ width: "24px", height: "24px" }}
              />
            }
            color="#D32F2F"
            className="card-item"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <Card
            title="รายจ่ายจากบัตรเครดิต"
            // value={formatCurrency2Digit(fetchData?.sumAllProductCostPrice || 0)}
            value={formatCurrency2Digit(fetchData?.sumBuyByChannel?.["บัตรเครดิต"] || 0)}
            icon={
              <img
                src={creditCardIcon}
                alt="Credit Card Icon"
                style={{ width: "24px", height: "24px" }}
              />
            }
            color="#D32F2F"
            className="card-item"
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} style={{ marginTop: "16px", height: "auto" }}>
        <Grid
          item
          xs={12}
          md={9.5}
          sx={{ height: { xs: "auto", md: 500 } }}
          // style={{ height: "auto" }}
        >
          <Box
            sx={{
              height: "100%",
              borderRadius: 3,
              backgroundColor: "#fff",
              boxShadow: "0 0 20px rgba(91, 71, 188, 0.2)",
              padding: 5,
            }}
          >
            <SalesChart logs={fetchData?.logs7Days} />
          </Box>
        </Grid>
        <Grid item xs={12} md={2.5} style={{ height: "100%" }}>
          <Grid container spacing={2} style={{ height: "100%" }}>
            <Grid item xs={12}>
              <Card
                title="รายรับ"
                // value={formatCurrency2Digit(fetchData?.sumRevenue || 0)}
                value={formatCurrency2Digit(totalRevenue)}
                icon={<InboxIcon />}
                // info={metric.info}
                color="#00BB9F"
                className="card-item"
              />
            </Grid>
            <Grid item xs={12}>
              <Card
                title="รายจ่าย"
                // value={formatCurrency2Digit(fetchData?.sumAllExpenditure || 0)}
                value={formatCurrency2Digit(totalExpenditure)}
                icon={<OutboxIcon />}
                // info={metric.info}
                color="#D32F2F"
                className="card-item"
              />
            </Grid>
            <Grid item xs={12}>
              <Card
                title="กำไร"
                // value={formatCurrency2Digit(fetchData?.totalProfit || 0)}
                value={formatCurrency2Digit(totalProfit)}
                icon={<TrendingUpIcon />}
                // info={metric.info}
                color="#007AFF"
                className="card-item"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={2}
        // className="table-container"
        style={{ marginTop: "20px" }}
      >
        <Grid item xs={12} md={6}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h6" className="table-title">
              สินค้าล่าสุด
            </Typography>
            <GradientButton
              onClick={() => {
                navigate("/pawn/buy_items_pawn");
              }}
            >
              ดูสินค้าทั้งหมด
            </GradientButton>
          </Grid>

          <ProductTable
            rows={fetchData?.allProductsSort}
            column={[
              { Header: "รหัสสินค้า", accessor: "product_code" },
              { Header: "ชื่อสินค้า", accessor: "product_name" },
              { Header: "วันที่", accessor: "created_date" },
            ]}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h6" className="table-title">
              รายการล่าสุด
            </Typography>
            <GradientButton
              onClick={() => {
                navigate("/pawn/list_by_customer_pawn");
                // Handle click actions here
              }}
            >
              ดูรายการทั้งหมด
            </GradientButton>
          </Grid>
          {/* {fetchData?.allProductsSort?.length > 0 ? (
            <> */}
          <ProductTable
            rows={fetchData?.allOrderLog}
            column={[
              { Header: "รหัสสินค้า", accessor: "order_code" },
              { Header: "ชื่อลูกค้า", accessor: "customer" },
              { Header: "วันที่", accessor: "created_date" },
              // { Header: "รหัสสินค้า", accessor: "product_code" },
              // { Header: "ชื่อลูกค้า", accessor: "customer" },
              // { Header: "วันที่", accessor: "created_date" },
            ]}
          />
          {/* <div>loadding</div> */}
          {/* </>
          ) : (
            <>
              <div>tes</div>
            </>
          )} */}
        </Grid>
      </Grid>

      <Modal open={isModalOpen} onClose={handleModalClose} />
      {/* </Container> */}
    </div>
  );
};

export default Dashboard;

//Frontend
// import React, { useState } from "react";
// import api from "_api";

// function ICReader() {
//   const [cardData, setCardData] = useState("");
//   const [status, setStatus] = useState("Ready to connect");

//   // Function to connect to the USB device
//   async function connectToDevice() {
//     try {
//       setStatus("Requesting device...");

//       // Request the USB device using WebUSB API
//       const device = await navigator.usb.requestDevice({
//         filters: [{ vendorId: 0x04e6, productId: 0x5810 }],
//       });

//       console.log("Device selected:", device);

//       // Send device details to the backend
//       setStatus("Sending device details to the server...");
//       const result = await api.pawn.connectUsbDevice({
//         vendorId: device.vendorId,
//         productId: device.productId,
//       });

//       if (result.isStatus) {
//         setCardData(result.data.cardData);
//         setStatus("Data received successfully");
//       } else {
//         setStatus(`Failed: ${result.message}`);
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       setStatus("Failed to connect or read card data");
//     }
//   }

//   return (
//     <div>
//       <h1>IC Reader</h1>
//       <p>Status: {status}</p>
//       <button onClick={connectToDevice}>Connect and Read</button>
//       {cardData && <pre>{JSON.stringify(cardData, null, 2)}</pre>}
//     </div>
//   );
// }

// export default ICReader;
